import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { FrattaleService } from 'src/app/services/frattale.service';

@Component({
  selector: 'app-operative',
  standalone: true,
  templateUrl: './operative.component.html',
  styleUrls: ['./operative.component.scss'],
  imports: [MdbTableModule, CommonModule, ReactiveFormsModule]
})
export class OperativeComponent implements OnInit {

  headers: any = ['ID', 'giorno', 'market', 'verso', 'h1', 'enter',
    'ritracciamento', 'stop loss', 'swing', 'Selezionato', 'rawal'/*, 'week' , 'min', 'max' */]
  tableData: any = []
  datiCompleti: any = []
  listaItemCompleti: any = []
  entrate: any = []
  loadingData: boolean = false
  isLocalhost: boolean = true
  updating: boolean = false
  dates: any = []
  comboDate: FormControl = new FormControl()

  constructor(private service: FrattaleService, private ref: ChangeDetectorRef) {
    //this.isLocalhost = service.isLocalhost()
  }

  ngOnInit(): void {
    this.caricaDati()
  }

  caricaDati() {
    this.tableData = []
    this.dates = []
    this.loadingData = true
    this.service.dbangOperative().subscribe((data: any) => {
      if (data['res'] == 'ok') {
        let d = data['data']
        console.log(d)
        d.forEach((element: any) => {
          this.listaItemCompleti.push({ id: element.id, completo: false })
          //if (element.enter > 0) {
          element.giorno = element.giorno.substring(0, 10)
          let arr = element.giorno.split('-')
          arr = arr.reverse()
          element.giorno = arr.join('-')
          element.entrata = false
          //}
        });
        this.datiCompleti = d
        this.tableData = d
        this.dates = this.popolaComboDate()
      } else {
        console.log(data)
      }
      this.loadingData = false
    })
  }

  popolaComboDate() {
    let arr: any = []
    this.datiCompleti.forEach((item: any) => {
      if (arr.indexOf(item.giorno) == -1) {
        arr.push(item.giorno)
      }
    })
    return arr
  }

  cambiaData() {
    let data = this.comboDate.value
    let datiOggi = this.datiCompleti.filter((item: any) => item.giorno == data, data)
    this.tableData = datiOggi.length > 0 ? datiOggi : this.datiCompleti
  }

  updateData() {
    this.updating = true
    this.listaItemCompleti.map((item: any) => {
      item.completo = false
    })
    this.tableData.forEach((item: any) => {
      // controllo trading
      if (item.enter > 0) {
        this.service.realTimeHilo(item.market).subscribe((data: any) => {
          // controllo lista completa
          let mio = this.listaItemCompleti.find((lui: any) => lui.id = item.id, item)
          if (mio) {
            mio.completo = true
            let totaleCompleti = this.listaItemCompleti.reduce((prev: any, curr: any) => curr.completo ? prev : prev++, 0)
            if (totaleCompleti == 0) {
              this.updating = false
            }
            if (data['res'] == 'ok') {
              if (item.verso == 'BUY') {
                if (item.swing == "0") {
                  if (data['data']['vmax'] > item.enter) {
                    item.entrata = true
                  }
                } else {
                  if (parseFloat(data['data']['vmin']) < parseFloat(item.enter)) {
                    item.entrata = true
                  }
                }
              } else if (item.verso == 'SELL') {
                if (item.swing == "0") {
                  if (parseFloat(data['data']['vmin']) < parseFloat(item.enter)) {
                    item.entrata = true
                  }
                } else {
                  if (parseFloat(data['data']['vmax']) > parseFloat(item.enter)) {
                    item.entrata = true
                  }
                }
              }
            } else {
              console.log(data)
              item.entrata = false
            }
            console.log(item.market, item.entrata)
          }
          this.updating = false
          //this.ref.detectChanges();
        })
      } else {
        item.entrata = false
      }
    })
  }

}
